import TableHead from 'components/Shared/Table/TableHeadRow/TableHeadRow'

export default TableHead
